import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const gridTitleStyles = makeStyles((theme: Theme) =>
    createStyles({
        subText: {
            color: "#7E858E",
            padding: "5px 0px 5px 5px",
            marginBottom: "20px",
        },
        button: {
            "&:hover": {
                backgroundColor: "inherit",
            },
        },
        title: {
            display: "inline",
        },
        selectedTitle: {},
        unselectedTitle: {
            color: "gray",
        },
    })
);
